import React from 'react'

const AchievementsAuthContext = React.createContext()

export default AchievementsAuthContext
